import { isNotEmpty } from '@lhb/func';

/** 踩点坐标允许接口字符串和地图数值，空值不能被转换为 0。 */
export function hasSpotSurveyCoordinates(lng: any, lat: any) {
  return [lng, lat].every(value => isNotEmpty(value) && String(value).trim() !== '' && Number.isFinite(Number(value)));
}

/** 经纬度统一按经度在前、各 6 位小数展示。 */
export function formatSpotSurveyCoordinates(lng: any, lat: any) {
  return hasSpotSurveyCoordinates(lng, lat) ? `${Number(lng).toFixed(6)},${Number(lat).toFixed(6)}` : '';
}
